/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Nice_Robin_SingInputs */

const en_calm_nice_robin_sing = /** @type {(inputs: Calm_Nice_Robin_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL to a custom image displayed after the intro slide.`)
};

const de_calm_nice_robin_sing = /** @type {(inputs: Calm_Nice_Robin_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL zu einem benutzerdefinierten Bild, das nach der Intro-Folie angezeigt wird.`)
};

/**
* | output |
* | --- |
* | "URL to a custom image displayed after the intro slide." |
*
* @param {Calm_Nice_Robin_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_nice_robin_sing = /** @type {((inputs?: Calm_Nice_Robin_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Nice_Robin_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_nice_robin_sing(inputs)
	return de_calm_nice_robin_sing(inputs)
});